export default __webpack_public_path__ + "static/media/logo.cb3bd3c3.png";